import {CssUnitDimensionRestDto} from "@/api/pharma-cms-content-page/models";
import {CssUnitEnum} from "@/api/enums/css-unit-enum";

export class CssUnitDimensionRestDtoModel implements CssUnitDimensionRestDto {
    value: number;
    unit_code: CssUnitEnum;

    constructor(value: number, unit_code: CssUnitEnum) {
        this.value = value;
        this.unit_code = unit_code;
    }

    static createWithDefaults(): CssUnitDimensionRestDtoModel {
        return new this(0, CssUnitEnum.REM);
    }

    static cloneFrom(source: CssUnitDimensionRestDto): CssUnitDimensionRestDtoModel {
        return new this(source.value, source.unit_code);
    }
}
